import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiBaseUrl } from "../../http";
import { QueryUrl } from "../../Utils";
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import {
  Conversation,
  IMessagerie,
  MessagerieFormData,
} from "./messagerie.type";

export const MessagerieApi = createApi({
  reducerPath: "messagerieApi",
  tagTypes: [
    "messagerieList",
    "messagerieBySlug",
    "allMessageriesList",
    "conversationByUser",
    "messagesByConversation",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    getAllMessagerieList: build.query<any, void>({
      providesTags: ["allMessageriesList"],
      query: () => {
        return "messages/";
      },
    }),
    getListMessageries: build.query<PaginationResults<IMessagerie>, TypeQuery>({
      providesTags: ["messagerieList"],
      query: (query) => QueryUrl("messages/", query),
    }),

    addOrEditMessagerie: build.mutation<
      IMessagerie,
      { slug?: string; data: MessagerieFormData | FormData }
    >({
      query: ({ slug, data }) => ({
        url: slug ? `messages/${slug}/` : `messages/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["messagerieList", "conversationByUser"],
    }),
    deleteMessagerie: build.mutation<IMessagerie, string>({
      query: (slug) => ({
        url: `messages/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["messagerieList"],
    }),
    messagerieBySlug: build.query<IMessagerie | any, string>({
      query: (slug) => `messages/${slug}/`,
      providesTags: ["messagerieBySlug"],
    }),
    conversationByUser: build.query<Conversation[], TypeQuery>
    ({
      query: ({ slug, ...query }) => QueryUrl(`user/${slug}/conversations/`, query),
      providesTags: ["conversationByUser"],
    }),
    markAllAsRead: build.query<Conversation[], string>({
      query: (slug) => `user/${slug}/marquer_tout_comme_lu/`,
      providesTags: [
        "messagerieList",
        "messagerieBySlug",
        "allMessageriesList",
        "conversationByUser",
        "messagesByConversation",
      ],
    }),
    messagesByConversation: build.query<IMessagerie | any, string>({
      query: (slug) => `conversation/${slug}/messages/`,
      providesTags: ["messagesByConversation"],
    }),
    updateReadMessage: build.mutation<IMessagerie, MessagerieFormData>({
      query: ({ slug, ...data }) => ({
        url: `messages/${slug}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["messagerieList", "conversationByUser"],
    }),
    allConversations: build.query<PaginationResults<Conversation>, TypeQuery>
    ({
      query: (query) => QueryUrl(`conversations/`, query),
      providesTags: ["conversationByUser"],
    }),
  }),
});

export const {
  useGetAllMessagerieListQuery,
  useAddOrEditMessagerieMutation,
  useGetListMessageriesQuery,
  useLazyMessagerieBySlugQuery,
  useDeleteMessagerieMutation,
  useLazyConversationByUserQuery,
  useConversationByUserQuery,
  useMessagesByConversationQuery,
  useLazyMessagesByConversationQuery,
  useUpdateReadMessageMutation,
  useMarkAllAsReadQuery,
  useLazyMarkAllAsReadQuery,
  useLazyAllConversationsQuery,
} = MessagerieApi;
